module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Home-1a07697614499efa2389d5b8ec3dd451.svg";